import React from 'react';
import { Colors } from '../../../constants';
import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

function getStyledChip(selected: boolean, limitWidth: boolean) {
    return styled(Chip)({
        color: selected ? Colors.white : Colors.navy,
        backgroundColor: `${selected ? Colors.turquoise : Colors.lightTurq} !important`,
        fontWeight: 700,
        minHeight: 32,
        maxHeight: 70,
        margin: '5px',
        maxWidth: limitWidth ? 200 : 'unset',
    });
}

interface IProps {
    label: string;
    onClick: () => void;
    selected: boolean;
    limitWidth?: boolean;
}

export default function OptionChip({ label, onClick, selected, limitWidth = false }: IProps) {
    const StyleChip = getStyledChip(selected, limitWidth);
    return <StyleChip label={label} onClick={onClick} />;
}
